export default __webpack_public_path__ + "db245d4709df92aef15d0ca671499d02.png";